<div class="new-content" *ngIf="!pane; else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <div class="content" [class.mobile]="deviceService.isMobile()">
    <ng-template [ngIf]="!!blockTitle?.title">
      <app-library-title [title]="blockTitle"></app-library-title>
    </ng-template>

    <div
      *ngIf="isAsIfTeacher"
      class="filter-block"
      [class.mobile]="deviceService.isMobile()"
      [class.move-top]="isAuthenticated">
      <div class="filter-scroll">
        <ul class="filter-list">
          <li
            *ngFor="let filter of tabs; let i = index; trackBy: trackByFn"
            class="filter-item"
            [class.selected]="filter.id === activeTab?.id"
            (click)="onSelectTab(filter)">
            <span class="filter-label">{{ filter.title | customLocale }}</span>
            <div appRedPoint class="red-point" [event]="redPointEvent(filter)"></div>
          </li>
        </ul>
      </div>
      <on-ui-button
        *ngIf="!deviceService.isMobile()"
        label="my-library.actions.create-lesson"
        class="poutline"
        (onclick)="onCreateLesson()">
      </on-ui-button>

      <div *ngIf="deviceService.isMobile()" class="create-item" (click)="onCreateLesson()">
        <div class="action-icon-wrap">
          <app-icon [width]="10" [height]="10" icon="plus"></app-icon>
        </div>
      </div>
    </div>

    <!-- ITEMS -->
    <div *ngFor="let lesson of rawContentItems; let i = index; trackBy: trackContentByFn" class="block">
      <app-library-content-mini
        [content]="lesson"
        (clicked)="onClickedCard()"
        (openLessonInModal)="onToggleLessonInModal($event)">
      </app-library-content-mini>
    </div>
    <!-- /ITEMS -->

    <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
    <span inViewport (inViewportAction)="onInViewportBottomChange($event)"></span>

    <ng-container *ngIf="!rawContentItems?.length && !pane?.loading" [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-no-content-stub
    [icon]="'header-lesson-stub'"
    (click)="goSignup($event)"
    [text]="isGuest ? activeTab?.stub_guest : activeTab?.stub">
  </app-no-content-stub>
</ng-template>

<app-modal *ngIf="openedLesson && !deviceService.isMobile()" (closed)="openedLesson = null">
  <app-modal-body>
    <app-status-badge
      *ngIf="isOnModeration || isDeclined"
      [status]="openedLesson.moderation_status"
      [reason]="openedLesson.moderation_message">
    </app-status-badge>
    <app-content-card class="modal" [item]="openedLesson"></app-content-card>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="openedLesson && deviceService.isMobile()" (closed)="openedLesson = null"
  >>
  <app-mobile-modal-body>
    <div class="card">
      <app-status-badge
        *ngIf="isOnModeration || isDeclined"
        [status]="openedLesson.moderation_status"
        [reason]="openedLesson.moderation_message">
      </app-status-badge>
      <app-content-card class="modal" [displayMode]="'content_page'" [item]="openedLesson"></app-content-card>
    </div>
  </app-mobile-modal-body>
</app-mobile-modal>
